export function roundMoney(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return 0;
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function formatMoneyValue(amount) {
  const rounded = roundMoney(amount);
  return Number.isInteger(rounded)
    ? String(Math.trunc(rounded))
    : rounded.toFixed(2);
}

export function formatMoney(amount, symbol = "₵") {
  return `${symbol}${formatMoneyValue(amount)}`;
}
